<!--首页-->
<template>
  <div>
    <el-carousel trigger="click"
                 :height="imgHeight+'px'"
                 style="overflow-y:hidden">
      <el-carousel-item v-for="(item,index) in bannerLists"
                        :key="index">
        <img :ref="imgHeight" :src="`${imgSrcPrefix}${item}`" v-if="bannerLists.length>0"
             alt
             class="bannerImg">
      </el-carousel-item>
    </el-carousel>

    <ul class="homeList">
      <li class="homeMain"
          v-for="(item,index) in productListData"
          :key="index"
          v-show="isMasking">
        <div class="homeImg"
             @click="detailsRouter(item)">
          <img :src="`${imgSrcPrefix}${item.productImg}`"
               :alt="item.categoryName">
        </div>
        <div class="homeTit">
          <h2 :class="item.productName.length > 6 ? 'homeTit-title2' : 'homeTit-title'">
            {{item.productName}}
          </h2>
          <div v-if="item.productClassification == 1">
              <p>仅对长期合作客户开放</p>
              <p>折扣利率、资料简化</p>
              <p>融资比例上限提高</p>
          </div>
          <div v-if="item.productClassification == 2">
              <p></p>
              <p></p>
              <p>企业应收转让</p>
              <p>融资速度快</p>
          </div>
          <div v-if="item.productClassification == 3">
              <p></p>
              <p></p>
              <p>买方确权应付</p>
              <p>利率相对优惠</p>
          </div>
          <div v-if="item.productClassification == 4">
              <p></p>
              <p></p>
              <p>仅对战略合作买方体系开放</p>
              <p>解决立账期间短时资金需求</p>
          </div>
          <div v-if="item.productClassification == 5">
              <p></p>
              <p></p>
              <p>提供票据融资咨询服务</p>
              <p>多方合作、渠道无忧</p>
          </div>
          <div v-if="item.productClassification == 6">
            <p></p>
            <p></p>
            <p>融资比例100%</p>
            <p>融资成本较低</p>
          </div>

          <a @click="detailsRouter(item)"
          :class="item.userName">产品详情</a>
        </div>
      </li>
    </ul>

  </div>
</template>
<script>
import api from '../api/common.js';
import { mapGetters, mapActions } from 'vuex';
import * as types from '../vuex/types/type';
import productsApi from '../api/products/products.js';

export default {
  data () {
    return {
      imgHeight: '', // banner自适应高度
      isMasking: true,
      customerType: '1', // 企业或个人标记
      classifyArr: [], // 获取的首页列表数据
      productListData: '', // 产品分类数据
      productListArr: [], // 产品分类数据
      productListObj: [], // 产品分类数据
      bannerLists: []
    };
  },
  computed: {
    ...mapGetters({
      imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
      userInfo: types.GET_USER,
    })
  },

  methods: {
    ...mapActions({
      setAlertMessage: types.SET_FAIL_MESSAGE
    }),
    // 图片自适应
    setSize () {
      this.$nextTick(function () {
        // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
        this.imgHeight = document.body.clientWidth * 390 / 1920;
      });
    },

    getBannerLists(){
      api.getIndexInfo().then((res) => {
          if(Number(res.data.code)==0){
            this.bannerLists=res.data.data.bannerFileIds;
          }
      })
    },

    productsListData () {
      const _this = this;
      productsApi
        .getProductListData({
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          isRecommend:1
        })
        .then((res) => {
          if (res.rspcode == 1) {
            const result = [];
            for (let i = 0, len = res.data.proList.length; i < len; i ++) {
              if(res.data.proList[i].productClassification == 1){//池保理
                  res.data.proList[i].userName = 'btn';
              }else if(res.data.proList[i].productClassification == 2){//正向保理
                  res.data.proList[i].userName = 'btn2';
              }else if(res.data.proList[i].productClassification == 3){//反向保理
                  res.data.proList[i].userName = 'btn3';
              }else if(res.data.proList[i].productClassification == 4){//送货融资
                  res.data.proList[i].userName = 'btn4';
              }else if(res.data.proList[i].productClassification == 5){//票据融资
                  res.data.proList[i].userName = 'btn5';
              }else if(res.data.proList[i].productClassification == 6){//供应链融资
                  res.data.proList[i].userName = 'btn6';
              }
            }
            const newObject = [];
            for (let k = 0; k < result.length; k++) {
              newObject.push(...result[k]);
            }
            _this.productListData = res.data.proList;
            _this.productListObj = res.data.proList;
            _this.triggerData(res.data.proList);
          }
        })
        .catch((error) => {});
    },

    // 详情跳转
    detailsRouter (item) {
      const productId = item.productId;
      const categoryCode = item.proCategoryValue;
      const productName = item.productName;
      const customerType = this.$route.query.customerType;
      if (categoryCode == '1003') {
        const yanse = productName.includes('供应链') ? 1 : 2;
        this.$router.push({
          path: '/factoring/',
          query: {
            customerType,
            productId,
            productName,
            categoryCode,
            yanse
          }
        });
      } else {
        this.$router.push({
          path: '/product/',
          query: {
            customerType,
            productId,
            categoryCode
          }
        });
      }
    },
    triggerData (list = []) {
      this.productListArr = [];
      const length = list.length;
      for (let i = 0; i < length; i++) {
        const item = list[i];
        this.productListArr.push(item);
        if (item.proCategoryValue == '1003') {
        }
      }
      const length1 = this.productListArr.length;
      if (length1 >= 8) {
        this.productListData = this.productListArr.slice(0, 8);
        return;
      }
      this.productListData = this.productListArr;
    },

  },

  created () {
    this.productsListData();
  },

  mounted () {
    this.getBannerLists();
    this.triggerData();
    this.setSize();
    window.addEventListener('resize', () => {
      this.imgHeight = this.$refs.image[0].height;
    });
  }
};
</script>


<style lang="scss">
.bannerImg {
  width: 100%;
  min-width: 1400px;
}

.homeList {
  width: 1140px;
  margin: 0 auto;
  padding: 100px 0 10px 0;
  @include clear;
  .homeMain {
    width: 540px;
    height: 270px;
    @include floatLeft;
    margin-bottom: 68px;
    text-align: center;
    box-shadow: 2px 2px 5px #ccc;
    box-sizing: border-box;
    &:hover {
      box-shadow: 2px 2px 10px #444444;
      cursor: pointer;
    }
    &:nth-of-type(odd) {
      margin-right: 60px;
    }
    .homeImg {
      width: 270px;
      height: inherit;
      position: relative;
      float: left;
      img {
        width: 270px;
        height: 270px;
      }
      p {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        line-height: 270px;
        font-size: 75px;
        color: #fff;
      }
    }
    .homeTit {
      width: 270px;
      padding: 27px;
      box-sizing: border-box;
      float: right;
      .homeTit-title {
        font-size: 28px;
        a {
          color: #00c0ff;
        }
      }
      .homeTit-title2 {
        font-size: 19px;

        a {
          color: #00c0ff;
        }
      }
      p {
        padding-top: 16px;
        font-size: 16px;
        color: #333;
      }
      span {
        font-size: 32px;
        line-height: 64px;
        color: #00c0ff;
      }
      ul {
        li {
          @include floatLeft;
          font-size: 14px;
          padding-left: 20px;
          text-align: center;

          a {
            color: #666;
          }
        }
      }
      .btn {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #FF653F;
        border-radius: 50px;
        margin-top: 45px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
      .btn2 {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #4287EE;
        border-radius: 50px;
        margin-top: 38px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
      .btn3 {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #9567EE;
        border-radius: 50px;
        margin-top: 45px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
      .btn4 {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #9C745A;
        border-radius: 50px;
        margin-top: 45px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
      .btn5 {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #f3b200;
        border-radius: 50px;
        margin-top: 45px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
      .btn6 {
        display: block;
        width: 160px;
        line-height: 36px;
        background: #76BC42;
        border-radius: 50px;
        margin-top: 45px;
        font-size: 18px;
        margin-left: 35px;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Index.vue?1e8b7041